import { useContext } from "react";

import { SdkContext } from "../../providers/SdkProvider";

export const useSdk = () => useContext(SdkContext).sdk;
